import React, { useEffect, useState } from 'react';
import Episode from './Episode';
import FilterMenu from './FilterMenu.js'
import styles from './index.module.css'
import preachImage from '../../images/preach2.jpeg'
import { BsSpotify } from "react-icons/bs";
import usePageData from '../../components/usePageData.js';
import LoadingScreen from '../../components/LoadingScreen.js';
import Footer from '../../../Footer/Footer.js';

export default function Praedikner ()  {
  const { data, loading } = usePageData("Praedikener");

  //global parameters:
  const [episodes, setEpisodes] = useState([]);
  const [titleFilter, setTitleFilter] = useState('');
  const [scriptureFilter, setScriptureFilter] = useState('');
  const [preacherFilter, setPreacherFilter] = useState('');
  const [filterResults, setFilterResults] = useState([]);
  const API_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000/" : "https://api.hillerodfrimenighed.dk/";

  const monthNames = [ //Array to index the months
          'Jan', 'Feb', 'Marts', 'April', 'Maj', 'Juni', 
          'Juli', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];

  const reconstructEpisodes = (data) => {
    //preps the data

    const newData = data.map((element) => {
      // The title should be in the form of "Title#Preacher#Scripture XX,XX".
      const splitted = element.item.title.split('#');
      let title = '';
      if(splitted[0]!== undefined){
        title = splitted[0];
      }
      let preacher = '';
      if(splitted[1]!== undefined){
        preacher = splitted[1];
      }
      let scripture = '';
      if(splitted[2]!== undefined){
        // const splittedScripture = splitted[2].split(' ');
        scripture = splitted[2];
      }
      //rewrite the way the date i displayed
      let date = element.item.isoDate.split('T')[0];
      let splittedDate = date.split('-')
      let month = monthNames[splittedDate[1]-1]
      date = splittedDate[2] + '. ' + month + ' ' + splittedDate[0];

      
      const item = { title: title, scripture: scripture, preacher: preacher, guid: element.item.guid, isoDate: date, duration: element.item.itunes.duration, discription: element.item.content, url: element.item.enclosure.url, image: element.item.itunes.image};
      return item;
    });

    setEpisodes(newData);
  };

  //a useEffect which activates and set the filters if the filtermenues are engaged
  useEffect(() => {
    let filteredResults = '';
    if(titleFilter !== ''){
      filteredResults = episodes.filter(episode => ((episode.title).toLowerCase()).includes(titleFilter.toLowerCase()));
    } else if(scriptureFilter !== ''){
      filteredResults = episodes.filter(episode => ((episode.scripture).toLowerCase()).includes(scriptureFilter.toLowerCase()));
    } else if(preacherFilter !== ''){
      filteredResults = episodes.filter(episode => ((episode.preacher).toLowerCase()).includes(preacherFilter.toLowerCase()));
    } else {
      filteredResults = episodes;
    }
    
    setFilterResults(filteredResults);
  }, [episodes, titleFilter, scriptureFilter, preacherFilter])


    useEffect(() => {
      //makes a fetch call to backend, to retrieve all episodes
      async function getEpisodes() {

        const response = await fetch(`${API_URL}rss`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          if (data.length > 0){
            reconstructEpisodes(data);
            
          } else {
            setEpisodes([]);
          }
          
        } else {
          console.log("Error:", response.status);
        }
      }
      getEpisodes();
    },[])

  //Retruns the episodes, Is in itss own component 
  //such that the prep of the data can be done before rendering the episodes
  function Feed() {

    const [expandedId, setExpandedId] = useState(''); //Ceep track of which episode should be expanded and not

      return(
        <div className={styles.feed}>
            {filterResults.length > 0 ? (
                filterResults.map((episode) => (
                          
                  <Episode className={styles.episode} key={episode.guid} episode={episode} setExpandedId={setExpandedId} isExpanded={expandedId === episode.guid}></Episode>
                          
                ))
                ) :(  <h3>Ingen prædikener</h3>  )}
        </div>
      );
    }
  if (loading) return <LoadingScreen visible={loading}/>;

  return (
    <>
      <LoadingScreen visible={loading}/>
      <main className={styles.main}>
        <div className={styles.pageheader} style={{ backgroundImage: `linear-gradient(to bottom, rgba(245, 246, 252, 0.52), rgb(235, 211, 204, 0.60)), url(${preachImage})` }}>
          <h1 className={styles.headline} >{data.PageHeader.title}</h1>
          <p>{data.PageHeader.text}</p>
          <div>
            <a className={styles.spotify} href='https://open.spotify.com/show/0ZjwjEYqNU44VumIpoyEHG?si=f8789070cd554252'><BsSpotify></BsSpotify> Spotify</a>
          </div>
        </div>
        <FilterMenu episodes={episodes} setTitleFilter={setTitleFilter} setScriptureFilter={setScriptureFilter} setPreacherFilter={setPreacherFilter}></FilterMenu>
        
        <Feed></Feed>
        
      </main>
      <Footer/>
    </>
  );
};
  

